export const USER_SUCESS = "USER_SUCESS";
export const USER_REQUEST = "USER_REQUEST";
export const USER_DELETE = "USER_DELETE";